import {
  globalConstants,
  marketingAttributionReduxConstants,
} from "../../constants";

const { SUCCESS } = globalConstants;
const {
  DASHBOARD_MARKETING_ATTRIBUTION,
  GET_MARKETING_ATTRIBUTION_GRAPH_DATA,
  GET_MARKETING_ATTRIBUTION_REPORT_BODY,
  GET_MARKETING_ATTRIBUTION_PAGINATED_DATA,
} = marketingAttributionReduxConstants;

const initialState = {
  restaurantInfo: {},
  marketingAttributionPaginatedData: [],
  marketingAttributionPagination: {
    pageSize: 10,
    totalElements: 3,
    pageNumber: 0,
  },
  marketingAttributionGraphData: [],
  marketingAttributionReportBody: {},
  dashboardMarketingAttributionData: {},
};

export const marketingAttributionReducer = (state = initialState, action) => {
  switch (action.type) {
    case DASHBOARD_MARKETING_ATTRIBUTION + SUCCESS:
      return {
        ...state,
        dashboardMarketingAttributionData: action.data,
      };
    case GET_MARKETING_ATTRIBUTION_PAGINATED_DATA + SUCCESS:
      return {
        ...state,
        marketingAttributionPaginatedData: action.data?.data,
        marketingAttributionPagination: action.data?.page,
      };
    case GET_MARKETING_ATTRIBUTION_GRAPH_DATA + SUCCESS:
      return {
        ...state,
        restaurantInfo: action.data?.restaurantInfo,
        marketingAttributionGraphData: action.data?.uniqueDaysCount,
      };
    case GET_MARKETING_ATTRIBUTION_REPORT_BODY + SUCCESS:
      return {
        ...state,
        marketingAttributionReportBody: action.data,
      };
    default:
      return state;
  }
};
